import { JSX } from 'react';
import './addButton.css';

const AddButton = ({title, addFunction}:{ title: string, addFunction: () => void }): JSX.Element => {
    return (
        <button className='add-button' onClick={() => addFunction()}>
            <span>{title}</span>
        </button>
    ); 
};
      
export default AddButton;